import React, { useState } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import { useCursos } from "../../context/CursosContext"; // Assumindo que há contexto semelhante
import Sidebar from "../../components/sidebar/Sidebar";
import Header from "../../components/cursos/header/Header";
import Midia from "../../components/cursos/midia/Midia";
import DetalhesCurso from "../../components/cursos/detalhesCurso/DetalhesCurso";
import ActionFooter from "../../components/actionFooter/ActionFooter";
import { DashboardLayout, MainContent } from "../dash/styles";
import { Container } from "./styles";
import dayjs from "dayjs";

export default function CriarCursos() {
  const navigate = useNavigate();
  const { setCursos } = useCursos();

  const [cursoData, setCursoData] = useState({
    titulo: "",
    descricao: "",
    organizacao: "",
    vagas: null,
    dataInicio: null,
    dataFim: null,
    hora: null,
    local: "",
    tags: [],
    imagem: null,
    preview: "",
    status: "Upcoming",
    contatos: [{ id: Date.now() + Math.random(), telefone: "", email: "", redeSocial: "" }],
    conteudos: [{ titulo: "", itens: [""] }],
    destacado: false,
  });

  const handleSave = async () => {
    if (!cursoData.titulo || !cursoData.dataInicio || !cursoData.dataFim) {
      alert("Por favor, preencha o título, a data de início e a data de fim.");
      return;
    }

    const formData = new FormData();

    formData.append("titulo", cursoData.titulo);
    formData.append("descricao", cursoData.descricao);
    formData.append("organizacao", cursoData.organizacao);
    formData.append("dataInicio", dayjs(cursoData.dataInicio).toISOString());
    formData.append("dataFim", dayjs(cursoData.dataFim).toISOString());

    if (cursoData.hora) {
      formData.append("hora", dayjs(cursoData.hora).format("HH:mm"));
    }

    formData.append("local", cursoData.local);
    formData.append("status", cursoData.status);
    formData.append("destacado", String(cursoData.destacado));
    formData.append("vagas", cursoData.vagas !== null ? String(cursoData.vagas) : "null");

    formData.append("tags", JSON.stringify(cursoData.tags));
    formData.append("contatos", JSON.stringify(cursoData.contatos));
    formData.append("conteudos", JSON.stringify(cursoData.conteudos));

    if (cursoData.imagem instanceof File) {
      formData.append("imagem", cursoData.imagem);
    }

    try {
      const response = await api.post("/api/content/cursos", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setCursos((prev) =>
        Array.isArray(prev) ? [...prev, response.data] : [response.data]
      );

      alert("Curso criado com sucesso!");
      navigate("/cursos");
    } catch (error) {
      console.error("Erro ao salvar curso:", error);
      alert("Erro ao criar curso. Verifique o backend.");
    }
  };

  return (
    <DashboardLayout>
      <Sidebar />

      <Container>
        <Header
          title="Criar novo curso"
          description="Adicione um novo curso à plataforma"
          breadcrumbMain="Cursos"
          breadcrumbCurrent="Criar curso"
        />

        <MainContent>
          <Midia
            initialPreview={cursoData.preview}
            onFileSelect={(file, preview) =>
              setCursoData({ ...cursoData, imagem: file, preview: preview })
            }
          />

          <DetalhesCurso
            cursoData={cursoData}
            setCursoData={setCursoData}
          />

          <ActionFooter onSave={handleSave} />
        </MainContent>
      </Container>
    </DashboardLayout>
  );
}
